export class UserCMS {
    id_user: number;
    login: any;
    password: any;
    matricule: number;
    cin: any;
    valide: any;

   
}

